export const storageKeys = {
    momentsTypes: 'wc_player_moments:selected-types'
};